<div>
    <form [formGroup]="CIEstudianteFormGroup">
        <h1 class="main-div"><b>Consulta de Código de Estudiante</b></h1>
        <div class="main-div">
            <div class="card text-justify" style="width: 18rem;" *ngIf="!muestraRespuesta">
                <!-- <img src="../../../assets/LOGO.png" class="card-img-top" alt="trayecto S.A."> -->
                <div class="card-body">
                    <h5>Por favor coloque los dos apellidos del estudiante y abajo coloque los dos nombres del estudiante:</h5>
                    <mat-form-field>
                        <mat-label>Dos Apellidos Estudiante</mat-label>
                        <input matInput placeholder="Apellido(s) Estudiante" formControlName="ApellidosEstudiante"
                            required>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Dos Nombres Estudiante</mat-label>
                        <input matInput placeholder="Nombre(s) Estudiante" formControlName="NombresEstudiante">
                    </mat-form-field>
                    <div>
                        <button class="btn btn-warning" mat-button (click)="buscar()">Buscar</button>
                    </div>
                </div>

            </div>

            <div class="card text-justify" style="width: 18rem;" *ngIf="muestraRespuesta">
                <!-- <img src="../../../assets/LOGO.png" class="card-img-top" alt="trayecto S.A."> -->
                <div class="card-body">
                    <div *ngIf="hayResultado">
                        <h3>Se encontró:</h3>
                        <h2>Colegio:{{objetoDevuelto["Colegio"]}}</h2>
                        <h2>{{objetoDevuelto["Apellidos Alumno"]}}</h2>
                        <h2>{{objetoDevuelto["Nombres Alumno"]}}</h2>
                        <h1>Código: {{objetoDevuelto["Cód. Alumno"]}}</h1>
                    </div>
                    <div *ngIf="!hayResultado">
                        <h3>No se encontraron resultados!.</h3>
                    </div>
                    <div>
                        <button class="btn btn-warning" [formGroup]="CIEstudianteFormGroup" mat-button
                            (click)="nuevaBusqueda()">Realizar otra búsqueda</button>
                    </div>
                </div>

            </div>

        </div>
    </form>
</div>